import { WithStyles, withStyles } from '@mui/styles';
import { FirmRecord } from '@tassat/fred-definitions';

import { FirmActivityLogs } from './firmActivityLogs';
import { muiStyles } from './firmActivityLogsStyles';

export interface FirmActivityLogProps extends WithStyles<typeof muiStyles> {
    firm: FirmRecord;
}

export default withStyles(muiStyles)(FirmActivityLogs);